import React from 'react';
import { Volume2, HardHat, Dog, Car, Trash2, CloudRain, CheckCircle2 } from 'lucide-react';
export function DisruptionSection() {
  const concerns = [{
    icon: Volume2,
    title: 'Noise & Equipment',
    mitigation: 'Work hours: 8am-5pm weekdays only. No early morning heavy machinery.'
  }, {
    icon: HardHat,
    title: 'Driveway Access',
    mitigation: 'Temporary access paths maintained. We ensure you can get to your front door safely.'
  }, {
    icon: Dog,
    title: 'Pets & Kids Safety',
    mitigation: 'Work area fully fenced/barricaded. Tools secured at end of every shift.'
  }, {
    icon: Car,
    title: 'Parking During Work',
    mitigation: "We help arrange temporary parking solutions if street parking isn't an option."
  }, {
    icon: Trash2,
    title: 'Debris & Mess',
    mitigation: 'Daily cleanup. Debris removed same day. We sweep up before leaving.'
  }, {
    icon: CloudRain,
    title: 'Weather Delays',
    mitigation: 'Weather contingency built into schedule. You are notified immediately of any changes.'
  }];
  return <section className="py-16 bg-white md:py-24" data-id="element-401">
      <div className="container mx-auto px-4 md:px-6" data-id="element-402">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-403">
          <div data-id="element-404">
            <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-6" data-id="element-405">
              We Know You Are Worried About Disruption
            </h2>
            <p className="text-lg text-slate-600 mb-8" data-id="element-406">
              Construction is messy, loud, and inconvenient. We don't pretend it
              isn't. Instead, we have a strict protocol to minimize the impact
              on your daily life.
            </p>

            <div className="bg-primary/5 p-6 rounded-xl border border-primary/10" data-id="element-407">
              <h4 className="font-bold text-slate-900 mb-2" data-id="element-408">Our Promise:</h4>
              <p className="text-slate-700" data-id="element-409">
                We treat your property like our own. If we make a mess, we clean
                it up. If we break something (rare, but possible), we fix it.
                You will never be left guessing what's happening.
              </p>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-4" data-id="element-410">
            {concerns.map((item, index) => <div key={index} className="p-4 rounded-lg border border-slate-200 bg-slate-50 hover:bg-white hover:shadow-md transition-all duration-300" data-id="element-411">
                <div className="flex items-center gap-3 mb-3" data-id="element-412">
                  <item.icon className="h-5 w-5 text-slate-500" data-id="element-413" />
                  <h3 className="font-bold text-slate-900" data-id="element-414">{item.title}</h3>
                </div>
                <div className="flex items-start gap-2" data-id="element-415">
                  <CheckCircle2 className="h-4 w-4 text-green-500 mt-0.5 shrink-0" data-id="element-416" />
                  <p className="text-sm text-slate-600" data-id="element-417">{item.mitigation}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}